import { CarouselBackgrounds } from "./CarouselBackgrounds";
import { CarouselContent } from "./CarouselContent";
import { CarouselThumbnails } from "./CarouselThumbnails";
import { DEFAULT_CAROUSEL_SLIDES } from "./defaultCarouselSlides";
import { HeroCarouselProvider, useHeroCarousel } from "./useHeroCarousel";

export interface HeroCarouselSlide {
  videoUrl?: string;
  staticImageUrl?: string;
  title?: string;
  description?: string;
  logoUrl: string;
  ctaText?: string | React.ReactNode;
  route: string;
  thumbnailUrl: string;
  secondaryCtaText?: string | React.ReactNode;
  secondaryRoute?: string;
  gameId?: string;
  gameSlug?: string;
  gemsAmount?: number; // Total gems available for the game (from all quests)
}

function CarouselWithSwipe() {
  const { swipeHandlers } = useHeroCarousel();

  return (
    <div
      className="relative h-[420px] md:h-[480px] touch-pan-y md:touch-auto"
      {...swipeHandlers}
    >
      <CarouselBackgrounds />
      <div className="absolute inset-0 pb-16 md:pb-0 md:relative flex items-center justify-center md:justify-start">
        <CarouselContent />
      </div>
      <div className="absolute bottom-4 left-0 right-0 flex justify-center md:justify-end ">
        <CarouselThumbnails />
      </div>
    </div>
  );
}

export interface HeroCarouselProps {
  slides?: HeroCarouselSlide[];
}

export function HeroCarousel({ slides }: HeroCarouselProps) {
  return (
    <HeroCarouselProvider slides={slides ?? DEFAULT_CAROUSEL_SLIDES}>
      <CarouselWithSwipe />
    </HeroCarouselProvider>
  );
}
